import React, { useEffect, useRef, useState } from 'react';
import './element-data-display.styles.scss';
import BackButton from '@/components/SHARED/back-button/back-button.component';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import { faArrowsUpToLine, faBoxOpen, faCertificate, faCoins, faCubesStacked, faInfinity, faPen, faPercentage, faRankingStar, faReceipt, faRefresh, faRibbon, faTrophy } from '@fortawesome/free-solid-svg-icons';
import DataCard from '../../game-dashboard/data-card.component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Modal, { ModalAlert, ModalConfirm } from '@/components/modal/modal.component';
import Chart3 from '../../game-dashboard/chart3.component';
import { format, milliseconds, set } from 'date-fns';
import { sanitize } from '@/utils/sanitize';
import { formatNumber } from '@/utils/formatNumber';
import { UseCloudFunction } from '@/utils/firebase.utils';
import { useSelector } from 'react-redux';
import FullPageLoader from '@/components/loader/full-page-loader.component';
import { getGameElementsFromDb } from '@/utils/getDataFromDb';
import { completeGameElementData } from '@/components/PREVIEW/previewGameElements';

const ElementDataDisplay = ({
  gameData,
  gameStats,
  gameElements,
  playerList,
  gameActivity // DEPRECATED
}) => {

  const userProfile = useSelector(state => state.userData.userProfile);
  const screenSize = useSelector(state => state.contentData.screenSize);
  const [element, setElement] = useState(null);
  const [totalEarned, setTotalEarned] = useState(0);
  const [totalCompleted, setTotalCompleted] = useState(0);
  const [ collectionItemsEarned, setCollectionItemsEarned] = useState(0);
  const [totalCollectionItemsAllowed, setTotalCollectionItemsAllowed] = useState(0);
  const [totalAllowed, setTotalAllowed] = useState(Infinity);
  const [remaining, setRemaining] = useState(0);
  const [showLimitModal, setShowLimitModal] = useState(false);
  const [newLimit, setNewLimit] = useState(0);
  const [itemActivity, setItemActivity] = useState([]);
  const [owners, setOwners] = useState(null);
  const [elementTypePath, setElementTypePath] = useState(null);
  const [showAvailable, setShowAvailable] = useState(false);
  const [alertMessage, setAlertMessage] = useState(null);
  const [confirmMessage, setConfirmMessage] = useState(null);
  const [loading, setLoading] = useState(false);
  const { elementPath } = useParams();
  const approveRef = useRef();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!elementPath) return;
    getElementWithPath();

  }, [elementPath])

  useEffect(() => {
    if (!gameStats || !element) return;
    if (element.type === 'challenge') {
      setTotalCompleted(gameStats[element.id + '_approved'] ?? 0);
    } 
    else if (element.type === 'collection') {
      setTotalCompleted(gameStats[element.id + '_earned'] ?? 0);  
      let collectionItems = element.opt_itemList;
      let itemsEarned = 0;
      for (let i of collectionItems) {
        if (gameStats[i + '_earned']) {
          itemsEarned += gameStats[i + '_earned'];
        }
      }
      setCollectionItemsEarned(itemsEarned);
      setTotalCollectionItemsAllowed(collectionItems.length * gameData.playerCount);
    }
    else if (element.type === 'item' || element.type === 'badge' || element.type === 'level' || element.type === 'secretCode') {
      setTotalEarned(gameStats[element.id + '_earned'] ?? 0);

      if (!element.opt_limitTotal) {
        setRemaining(<FontAwesomeIcon icon={faInfinity} />);
        return;
      }
      let owned = 0;
      if (gameStats[element.id + '_earned']) {
        owned = gameStats[element.id + '_earned'] + (gameStats[element.id + '_purchased'] ?? 0);
      }
      let rem = element.opt_limitTotal - owned;
      setRemaining(rem);
    }
  }, [gameStats, element])

  // useEffect(() => {
  //     if (!element || !gameActivity) return;
  //     let actArr = Object.values(gameActivity)
  //     .filter(a => 
  //         a.elementId === element.id ||
  //         (
  //             a.data &&
  //             Object.values(a.data)
  //             .filter(d => d.id === element.id)
  //             .length > 0
  //         )
  //     )
  //     console.log(actArr);
  //     setItemActivity([...actArr])
  // }, [element, gameActivity])

  useEffect(() => {
    if (!element || !playerList) return;
    console.log(element);
    let type = element.type + 's';
    if (element.opt_itemType === 'prizepack') {
      type = element.opt_itemType + 's';
    }
    setElementTypePath(type);
    let players = Object.values(playerList)
      .filter(p =>
        !p.team &&
        p.status === 'active' &&
        p[type] &&
        p[type][element.id] &&
        p[type][element.id].count > 0
      )
    let playersWithDate = [];
    for (let p of players) {
      let newPlayer = { ...p };
      newPlayer.lastDate = itemActivity
        .filter(a => a.playerId === p.playerId).length > 0
        ?
        new Date(
          itemActivity
            .filter(ac => ac.playerId === p.playerId)
            .sort((a, b) => a.ts < b.ts ? 1 : -1)[0].ts
        )
        : null
      playersWithDate.push(newPlayer);
    }
    setOwners([...playersWithDate])
    if (element.type === 'badge') {
      setTotalAllowed(
        Object.values(playerList)
          .filter(p => !p.team && p.status === 'active')
          .length
      )
    } else if (element.opt_limitTotal) {
      setTotalAllowed(element.opt_limitTotal)
    } else {
      setTotalAllowed(<FontAwesomeIcon icon={faInfinity} />)
    }
  }, [element, playerList, itemActivity])

  function getElementWithPath() {
    if (location.pathname.includes('/preview/manager/')) {
      setElement(Object.values(completeGameElementData).find(e => e.path === elementPath));
      return;
    }
    getGameElementsFromDb({
      'path': elementPath,
      'gameId': gameData.gameId,
      'callback': callback,
      'once': true
    })
    function callback(data) {
      console.log(data);
      setElement(Object.values(data)[0]);
    }
  }

  function resetContributions() {
    if (location.pathname.includes('/preview/manager/')) {
      setAlertMessage('Sorry! Data cannot be saved in Preview Mode.');
      return;
    }
    setConfirmMessage(`Are you sure you want to reset the contribution total to zero? Your players' contribution history will not change. This action cannot be undone.`);
    approveRef.current = () => {
      continueReset();
    }

    async function continueReset() {
      setLoading(true);
      const res = await UseCloudFunction(
        'resetContributionTotal',
        {
          'gameId': gameData.gameId,
          'appId': userProfile.appId,
          'item': element,
          'ts': new Date().getTime()
        }
      )
      console.log(res);
      setLoading(false);
      if (res.error) {
        setAlertMessage('Something went wrong: ' + res.error);
        return;
      }
      setAlertMessage('Contributions successfully reset to zero.');
    }
  }

  return (
    <div className={`element-data-display ${screenSize}`}>
      <div className='element-data-content g-card'>
        <BackButton cancel={() => navigate(-1)} />
        <div className="g-space-1"></div>
        {
          (element) &&
          <div className='content'>
            <div className='title-box with-icon'>
              <ImageContainer
                src={element.icon}
                className='title-icon'
              />
              <div className='title-text'>
                <div className='card-title'>
                  {element.name}
                </div>
                <div className="g-space-0-5"></div>
                <div className='meta'>
                  <div dangerouslySetInnerHTML={{ __html: element.desc }}></div>
                </div>
              </div>
            </div>
            <hr />
            <div className={`card-row ${(
              showAvailable ||
              element.opt_itemType === 'contribution'
            )
              ? 'four-cards'
              : ''
              }`}>
              {/** 
               * FIRST CARD
               * 
               * Challenge/Collection: Completed
               * Badge/Item/PrizePack/Level/Code: Earned
               * Contribution: Contributed
               */}
              {
                (element.type === 'challenge' || element.type === 'collection')
                  ?
                  <DataCard
                    icon={faTrophy}
                    data={totalCompleted}
                    text="Completed" />
                  :
                  (
                    (
                      element.type === 'item' &&
                      element.opt_itemType !== 'contribution'
                    ) ||
                    element.type === 'badge' ||
                    element.type === 'level' ||
                    element.type === 'secretCode'
                  )
                    ?
                    <DataCard
                      icon={element.type === 'badge' ? faCertificate : faTrophy}
                      data={totalEarned}
                      text="Earned" />
                    :
                    (element.type === 'item' && element.opt_itemType === 'contribution')
                      ?
                      <DataCard
                        icon={faCubesStacked}
                        data={formatNumber(gameStats[element.id + '_contributions'] ?? 0)}
                        text="Contributed" />
                      :
                      null
              }

              {/** 
               * SECOND CARD
               * 
               * Challenge: Declined
               * Collection: Items Earned
               * Item/PrizePack: Purchased
               * Contribution: Goal
               * Badge/Level/Code: Total Allowed
               */}

              {
                (element.type === 'challenge')
                  ?
                  <DataCard
                    icon={faArrowsUpToLine}
                    data={gameStats[element.id + '_declined'] ?? 0}
                    text='Declined' />
                  :
                  (element.type === 'collection')
                    ?
                    <DataCard
                      icon={faCubesStacked}
                      data={collectionItemsEarned}
                      text='Items Earned' />
                    :
                    (
                      element.type === 'item' &&
                      element.opt_itemType !== 'contribution'
                    )
                    ?
                    <DataCard
                      icon={faReceipt}
                      data={gameStats[element.id + '_purchased'] ?? 0}
                      text='Purchased' />
                    :
                      (element.type === 'item' && element.opt_itemType === 'contribution')
                      ?
                      <DataCard
                        icon={faCubesStacked}
                        data={element.opt_contributionGoal}
                        text='Contribution Goal' />
                        :
                       (element.type === 'badge' || element.type === 'level' || element.type === 'secretCode')
                        ?
                        <DataCard
                          icon={faArrowsUpToLine}
                          data={totalAllowed}
                          text='Total Allowed' />
                        :
                        null
              }

              {/** 
               * THIRD CARD
               * 
               * Badge/Code: Percent Earned
               * Collection: Percent Earned
               * Item/PrizePack/Code: Total Allowed (opt_limitTotal)
               * Contribution: Percent Contributed
               */}

              {
                (element.type === 'badge' || element.type === 'secretCode')
                  ?
                  <DataCard
                    icon={faPercentage}
                    data={totalAllowed !== 0 ? ((totalEarned / totalAllowed) * 100).toFixed(0) + '%' : '0%'}
                    text='Percent Earned' />
                  :
                  (element.type === 'collection')
                    ?
                    <DataCard
                      icon={faPercentage}
                      data={
                        (!isNaN(totalCollectionItemsAllowed) && totalCollectionItemsAllowed !== 0) ?
                          ((collectionItemsEarned / totalCollectionItemsAllowed) * 100).toFixed(0) + '%'
                          :
                          '0%'
                      }
                      text='Percent Earned' />
                    :
                    (element.type === 'item' && element.opt_itemType !== 'contribution')
                      ?
                      <DataCard
                        icon={faArrowsUpToLine}
                        data={totalAllowed}
                        text='Total Allowed' />
                      :
                      (element.type === 'item' && element.opt_itemType === 'contribution')
                        ?
                        <DataCard
                          icon={faArrowsUpToLine}
                          data={element.opt_contributionGoal}
                          text='Contribution Goal' />
                        :
                        null

              }

              

            </div>
            <div className="g-space-1"></div>
            {
              (element.type === 'item') &&
              <div className='buttons'>
                {
                  (element.opt_itemType === 'contribution') &&
                  <button
                    className={`g-button ${screenSize === 'mobile'
                      ? 'tiny-btn'
                      : 'small-btn'
                      }`}
                    onClick={() => resetContributions()}>
                    <FontAwesomeIcon icon={faRefresh} />
                    Reset Contributions to Zero
                  </button>
                }
                <button
                  className={`g-button ${screenSize === 'mobile'
                    ? 'tiny-btn'
                    : 'small-btn'
                    }`}
                  onClick={() => navigate(`../items/edit/${element.path}`)}
                >
                  <FontAwesomeIcon icon={faPen} />
                  Edit Element
                </button>
              </div>
            }
            {
              (itemActivity) &&
              <>
                <div className='g-space-2'></div>
                <div className=''>
                  Recent Activity
                </div>
                <div className='graph-row'>
                  <Chart3
                    recentActivity={itemActivity}
                    chartHeight='175'
                  />
                </div>
              </>
            }
            <div className='g-space-2'></div>
            <div className='player-div'>
              <div className=''>Player List</div>
              <div className='g-space-1'></div>
              <div className='player-list'>
                {
                  (owners) &&
                  owners
                    .sort((a, b) => a.lastDate < b.lastDate ? 1 : -1)
                    .map(p => (
                      <button
                        key={p.playerId}
                        className={`g-button player-item med-btn ${p[elementTypePath][element.id].totalSpent ? 'four-wide' : ''}`}
                        onClick={() => navigate(`/manage/${gameData.path}/players/${p.path}`)}
                      >
                        <div className='name-div'>
                          {
                            (p.icon)
                              ?
                              <ImageContainer src={p.icon} />
                              :
                              <div
                                className='gradient'
                                style={{ 'background': p.gradient }}>
                                {p.fName[0]}
                              </div>
                          }
                          {p.lName ? `${p.lName}, ${p.fName}` : p.fName}
                        </div>

                        {
                          (itemActivity) &&
                          <div className='activity meta'>

                            Last Activity: {format(new Date(p.lastDate), "P")}
                          </div>
                        }
                        {
                          (elementTypePath) &&
                          <div className='count'>
                            Count: {p[elementTypePath][element.id].count}
                          </div>
                        }
                        {
                          (p[elementTypePath][element.id].totalSpent) &&
                          <div className='total'>
                            Total: <ImageContainer src='/images/icons/coin.png' className='coin-icon' />{formatNumber(p[elementTypePath][element.id].totalSpent)}
                          </div>
                        }
                      </button>
                    ))
                }
              </div>
            </div>
          </div>
        }
      </div>
      <Modal
        show={showLimitModal}
        cancel={() => setShowLimitModal(false)}
        closeButton={true}
        cls='narrow'
        text='Change Game-Wide Limit'
      >
        <div className='limit-modal-content'>
          <div className='field'>
            <label>Change Total Limit</label>
            <input
              type='number'
              min='0'
              value={
                newLimit ??
                0
              }
              onChange={(e) => setNewLimit(Number(e.target.value))}
            />
          </div>
        </div>
      </Modal>
      <ModalAlert
        show={alertMessage}
        cancel={() => setAlertMessage(null)}
        message={alertMessage} />
      <ModalConfirm
        show={confirmMessage}
        cancel={() => setConfirmMessage(null)}
        message={confirmMessage}
        onApprove={approveRef.current} />
      <FullPageLoader show={loading} />
    </div>
  )
}

export default ElementDataDisplay;